<template>
  <div
    id="map-view"
    ref="warp_map"
    style="height: calc(100vh + 17rem); z-index: 30"
    class="pt-0 pb-5"
  >
    <!-- calc(100vh - 0rem) -->
    <div id="map" ref="map" style="height: 100%; width: 100%"></div>
  </div>
</template>

<script>
import gmapsInit from "@/gmap/gmaps";
import moment from "moment-timezone";

export default {
  data() {
    return {
      google: null,
      map: null,
      warpMap: null,
    };
  },
  created() {
    this.initMap();
  },
  methods: {
    async initMap() {
      this.google = await gmapsInit();
      this.geocoder = new google.maps.Geocoder();
      const latlng = new google.maps.LatLng(10.18383, 100.60639);
      const options = {
        zoom: 6,
        center: latlng,
        streetViewControl: false,
        mapTypeControl: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        fullscreenControl: true,
        gestureHandling: "greedy",
        zoomControlOptions: {
          position: google.maps.ControlPosition.LEFT_CENTER,
        },
      };
      this.map = new google.maps.Map(this.$el.querySelector("#map"), options);
      this.warpMap = this.$el.querySelector("#warp_map");
      this.infoWindow = new google.maps.InfoWindow();
      //   google.maps.event.trigger(this.map, "resize");

      const symbolOne = {
        path: "M -2,0 0,-2 2,0 0,2 z",
        strokeColor: "#F00",
        fillColor: "#F00",
        fillOpacity: 1,
      };
      const symbolTwo = {
        path: "M -1,0 A 1,1 0 0 0 -3,0 1,1 0 0 0 -1,0M 1,0 A 1,1 0 0 0 3,0 1,1 0 0 0 1,0M -3,3 Q 0,5 3,3",
        strokeColor: "#00F",
        rotation: 45,
      };
      const symbolThree = {
        path: "M -2,-2 2,2 M 2,-2 -2,2",
        strokeColor: "#292",
        strokeWeight: 4,
      };

      const lineSymbol = {
        path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
      };
    },
    pad(num) {
      return ("0" + num).slice(-2);
    },
    hhmmss(secs) {
      var minutes = Math.floor(secs / 60);
      secs = secs % 60;
      var hours = Math.floor(minutes / 60);
      minutes = minutes % 60;
      return `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(secs)}`;
      // return pad(hours)+":"+pad(minutes)+":"+pad(secs); for old browsers
    },
    markerClickFunction1(train, latlng) {
      return (e) => {
        e.cancelBubble = true;
        e.returnValue = false;
        if (e.stopPropagation) {
          e.stopPropagation();
          e.preventDefault();
        }

        console.log("train >>>. ", train);

        const time = Number(train.Time);
        let infoHtml = `<div class="info">`;
        infoHtml += `<p>lat: ${train.lat}</p>`;
        infoHtml += `<p>lng: ${train.lng}</p>`;
        infoHtml += `<p>speed: ${train.Speed}</p>`;
        infoHtml += `<p>date: ${moment(train.Date, "DDMMYY").format(
          "DD/MM/YYYY"
        )} ${this.hhmmss(time)}</p>`;
        infoHtml += `<p>status: ${
          train.Status == "A"
            ? '<b style="color: green">Active</b>'
            : '<b style="color: gray">Inactive</b>'
        }</p>`;
        infoHtml += `</div>`;

        this.infoWindow.setContent(infoHtml);
        this.infoWindow.setPosition(latlng);
        this.infoWindow.open(this.map);
      };
    },
  },
};
</script>

<style scoped>
#map {
  position: relative;
  width: 100%;
  height: 100%;
}
#map-view {
  width: 100%;
  height: 100%;
}
</style>
